import React from 'react'
import TextArea from '../../../components/textArea/TextArea.component'
import { AirwayConstants } from '../airway/store/airway.constants'
import { getInitialAssessmentAirway } from '../airway/selectors/getInitialAssessmentAirway.selectors'
import { saveInitialAssessmentAirway, setComments } from '../airway/store/airway.actions'
import { useDispatch, useSelector } from 'react-redux'
import { getRespiratorySelector } from '../respiratory/selectors/respiratory.selector'
import { setRespComments, setBreathSoundsComments, saveRespiratory } from '../respiratory/store/respiratory.actions'
import { InitialAssessmentConstants } from '../store/initialAssessment.constants'
import { saveNeuro, setHeadFindings } from '../neuro/store/neuro.actions'
import { getNeuroSelector } from '../neuro/selectors/getNeuro.selector'
import { NeuroConstants } from '../neuro/store/neuro.constants'
import { getInitialAssessmentCardio } from '../cardio/selectors/getInitialAssessmentCardio.selectors'
import { CardioConstants } from '../cardio/store/cardio.constants'
import { saveCardio, setCvComments } from '../cardio/store/cardio.actions'
interface InitialAssessmentCommentsContentProps {
  title: string
  selectedOption: string
  fieldComment?: boolean
}

const InitialAssessmentCommentsContent: React.FC<InitialAssessmentCommentsContentProps> = ({
  title,
  selectedOption,
  fieldComment = false,
}) => {
  const dispatch = useDispatch()
  const initialAssessmentAirway = useSelector(getInitialAssessmentAirway)
  const RespiratoryData = useSelector(getRespiratorySelector)
  const { prNabc } = initialAssessmentAirway
  const { airComments } = prNabc
  const { respComments, cvBreathComments } = RespiratoryData
  let value = ''
  let charSize: any = ''
  let validationId = ''
  let action: (...args: any[]) => any
  const neuroState = useSelector(getNeuroSelector)
  const neuroComments = neuroState.headFindings
  const cardioState = useSelector(getInitialAssessmentCardio)
  const { cvComments } = cardioState.prNabc

  if (selectedOption === InitialAssessmentConstants.AIRWAY) {
    value = airComments
    validationId = AirwayConstants.SET_INITIAL_ASSESSMENT_AIRWAY_COMMENTS
    action = setComments
  }

  if (selectedOption === InitialAssessmentConstants.RESPIRATORY) {
    value = respComments
    action = setRespComments
  }

  if (selectedOption === InitialAssessmentConstants.NEURO) {
    value = neuroComments
    validationId = NeuroConstants.SET_HEADFINDINGS
    action = setHeadFindings
  }

  if (selectedOption === InitialAssessmentConstants.CARDIO) {
    value = cvComments
    validationId = CardioConstants.SET_CVCOMMENTS
    action = setCvComments
    charSize = 250
  }

  if (fieldComment) {
    value = cvBreathComments
    action = setBreathSoundsComments
    charSize = 250
  }

  const setCommentsOnChange = (e: CustomEvent) => {
    dispatch(action(e.detail.value))
    if (selectedOption === InitialAssessmentConstants.RESPIRATORY || fieldComment) {
      dispatch(saveRespiratory())
    }

    if (selectedOption === InitialAssessmentConstants.NEURO) {
      dispatch(saveNeuro())
    }

    if (selectedOption === InitialAssessmentConstants.AIRWAY) {
      dispatch(saveInitialAssessmentAirway())
    }

    if (selectedOption === InitialAssessmentConstants.CARDIO) {
      dispatch(saveCardio())
    }
  }

  return (
    <>
      <TextArea
        dataTestID={title.replaceAll(' ', '')}
        label={title}
        maxlength={charSize ? charSize : 500}
        value={value || ''}
        validationId={validationId}
        onChangeAction={setCommentsOnChange}
      />
    </>
  )
}

export default InitialAssessmentCommentsContent
